import React from 'react'
import AdminPage from 'pages/app/AdminPage'
import { Translator, useCurrentLocale } from '@morningtrain/react-translations'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import { Card } from 'ui'
import { ModelWithForm } from '@morningtrain/react-resources'
import { RouteParameterFilter } from 'support/filters'
import { Repeater } from '@morningtrain/react-fields-repeater-field'
import * as Icons from 'ui/icons'
import * as Displays from 'support/displays'
import StepPointOptions from 'pages/app/cleaning/partials/StepPointOptions'
import { Fieldset } from 'layouts'
import * as Fields from 'support/fields'
import EditTemplateHeader from 'pages/app/cleaning/partials/EditTemplateHeader'
import RedirectToEditOnCreatePipeline from 'support/pipelines/RedirectToEditOnCreatePipeline'
import TransformValueToObservableMaps from 'support/collections/TransformValueToObservableMaps'

export default function EditTemplate () {
  const locale = useCurrentLocale()

  return (
    <AdminPage>
      <Translator namespace='cleaning.edit_template'>
        <Can permission={Permissions.CLEANING_CHECKUPS_MANAGE}>
          <ModelWithForm resourceName='cleaning.category'>
            <TransformValueToObservableMaps name='steps' />

            {/* Filters */}
            <RouteParameterFilter name='cleaning_checkup_category' />

            {/* Handle redirect on save */}
            <RedirectToEditOnCreatePipeline routeName='app.cleaning.edit_template' />

            <EditTemplateHeader />

            <Fieldset cols={2}>
              <Fields.Input name='name_en' />
              <Fields.Input name='name_da' />
            </Fieldset>

            <Repeater
              name='steps'
              draggable
              collapsable
              appendNew={false}
              buttonClass='btn btn-sq btn-primary'
              addLabel={<Icons.Plus className='w-3 h-3' />}
              removeLabel={<Icons.Trash className='w-4 h-4' />}
              itemHeader={locale === 'en' ? <Displays.Text name='description_en' /> : <Displays.Text name='description_da' />}
            >
              <Card>
                <Fields.Hidden name='id' />
                <Fieldset cols={2}>
                  <Fields.Input name='description_da' />
                  <Fields.Input name='description_en' />
                </Fieldset>

                <Fieldset cols={4}>
                  <Fields.ImageFile name='one_point_image' />
                  <Fields.ImageFile name='two_point_image' />
                  <Fields.ImageFile name='three_point_image' />
                  <Fields.ImageFile name='four_point_image' />
                </Fieldset>
                <StepPointOptions />
              </Card>
            </Repeater>
          </ModelWithForm>
        </Can>
      </Translator>
    </AdminPage>
  )
}
